import * as api from '../../api/index.js';
import { Button, Modal } from 'react-bootstrap';
import TrailsMap from "../Trails/TrailsMap.js";
import { CircleMarker, Tooltip } from "react-leaflet";
import { useEffect, useState } from 'react';

/**
 * @param {{video: api.Video, benches: api.Bench[]}} params
 */
export default function AssignBenchesDialog({ video, benches, updateBenches, showDialog, setShowDialog }) {
    /** @type [api.Bench[], Function] */
    const [assignedBenches, setAssignedBenches] = useState([]);

    useEffect(() => {
        setAssignedBenches(benches.filter(b => b.videos.some(({ title }) => title === video.title)));
    }, [video, benches]);

    const getEventHandler = (bench) => ({
        click() {
            if (assignedBenches.includes(bench)) {
                setAssignedBenches(assignedBenches.filter(b => b !== bench))
            } else {
                setAssignedBenches([...assignedBenches, bench]);
            }
        },
    });

    async function saveChanges() {
        await api.updateVideoBenches(video, assignedBenches);
        updateBenches();
        setShowDialog(false);
    }

    return (
        <Modal show={showDialog} onHide={() => setShowDialog(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Assign Benches for <i>{video.title}</i></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TrailsMap>
                    {benches.map(bench => (
                        <CircleMarker key={Math.random()} eventHandlers={getEventHandler(bench)} fillOpacity={assignedBenches.includes(bench) ? 1 : 0} center={[bench.latitude, bench.longitude]}>
                            <Tooltip direction="top" permanent>#{bench.bench_number}</Tooltip>
                        </CircleMarker>
                    ))}
                </TrailsMap>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={saveChanges}>Save</Button>
                <Button variant="danger" onClick={() => setShowDialog(false)}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}